import { ReactComponent as Chatbots } from "../../../../../../assets/images/icons/chatbots.svg";
import { ReactComponent as CodeReview } from "../../../../../../assets/images/icons/codereview.svg";
import { ReactComponent as DocumentAnalysis } from "../../../../../../assets/images/icons/documentanalysis.svg";
import { ReactComponent as Forecast } from "../../../../../../assets/images/icons/forecast.svg";
import { ReactComponent as FraudDetector } from "../../../../../../assets/images/icons/protection.svg";
import { ReactComponent as NoiseCancelling } from "../../../../../../assets/images/icons/noisecancelling.svg";
import { ReactComponent as PersonalAssistant } from "../../../../../../assets/images/icons/personalassistant.svg";
import { ReactComponent as PersonalizedRecommendations } from "../../../../../../assets/images/icons/personalizedrecommendations.svg";
import { ReactComponent as Search } from "../../../../../../assets/images/icons/search.svg";
import { ReactComponent as TextAnalytics } from "../../../../../../assets/images/icons/textanalytics.svg";
import { ReactComponent as TextSummarize } from "../../../../../../assets/images/icons/textsummarize.svg";
import { ReactComponent as TextToSpeech } from "../../../../../../assets/images/icons/texttospeech.svg";
import { ReactComponent as SpeechToText } from "../../../../../../assets/images/icons/speechtotext.svg";
import { ReactComponent as Translation } from "../../../../../../assets/images/icons/translation.svg";
import { ReactComponent as UIdesign } from "../../../../../../assets/images/icons/uidesign.svg";
import { ReactComponent as Image } from "../../../../../../assets/images/icons/image.svg";
import { ReactComponent as HostAssistant } from "../../../../../../assets/images/icons/hostassistant.svg";
import { ReactComponent as WritingAssistant } from "../../../../../../assets/images/icons/writingassistant.svg";
import { ReactComponent as Home } from "../../../../../../assets/images/icons/aihome.svg";
import { ReactComponent as OS } from "../../../../../../assets/images/icons/os.svg";
import { ReactComponent as Game } from "../../../../../../assets/images/icons/game.svg";
import { ReactComponent as FileManagement } from "../../../../../../assets/images/icons/filemanagement.svg";
import { ReactComponent as Texture } from "../../../../../../assets/images/icons/texture.svg";
import { ReactComponent as Factory } from "../../../../../../assets/images/icons/factory.svg";
import { ReactComponent as MotionControl } from "../../../../../../assets/images/icons/motion.svg";
import { ReactComponent as MachineController } from "../../../../../../assets/images/icons/machine.svg";
import { ReactComponent as LogisticAutomation } from "../../../../../../assets/images/icons/logistics.svg";
import { ReactComponent as StockAnalysis } from "../../../../../../assets/images/icons/stock.svg";
import { ReactComponent as SmartCameras } from "../../../../../../assets/images/icons/smartcams.svg";
import { ReactComponent as ProcessOptimization } from "../../../../../../assets/images/icons/processoptimization.svg";
import { ReactComponent as MachineCalibration } from "../../../../../../assets/images/icons/calibration.svg";
import { ReactComponent as PredictiveIntelligence } from "../../../../../../assets/images/icons/predictiveintelligence.svg";
import { ReactComponent as MediatedConversations } from "../../../../../../assets/images/icons/mediatedconversations.svg";
import { ReactComponent as Metrics } from "../../../../../../assets/images/icons/metrics.svg";
import { ReactComponent as CustomerService } from "../../../../../../assets/images/icons/customerservice.svg";
import { ReactComponent as DataIntelligence } from "../../../../../../assets/images/icons/dataintelligence.svg";
import { ReactComponent as CallTracking } from "../../../../../../assets/images/icons/calltracking.svg";
import { ReactComponent as AiVoices } from "../../../../../../assets/images/icons/aivoices.svg";
import { ReactComponent as SoundCreation } from "../../../../../../assets/images/icons/soundcreation.svg";
import { ReactComponent as MediaOptimize } from "../../../../../../assets/images/icons/mediaoptimize.svg";
import { ReactComponent as VideoEdit } from "../../../../../../assets/images/icons/videoedit.svg";
import { ReactComponent as VideoCreation } from "../../../../../../assets/images/icons/videocreation.svg";
import { ReactComponent as ImageInhancer } from "../../../../../../assets/images/icons/imageinhancer.svg";
import { ReactComponent as AudioEditing } from "../../../../../../assets/images/icons/audioediting.svg";
import { ReactComponent as Objects } from "../../../../../../assets/images/icons/objects.svg";
import { ReactComponent as MediaTool } from "../../../../../../assets/images/icons/settings.svg";
import { ReactComponent as LanguageLearn } from "../../../../../../assets/images/icons/languagelearn.svg";
import { ReactComponent as VisualAi } from "../../../../../../assets/images/icons/visualai.svg";
import { ReactComponent as AutomatedML } from "../../../../../../assets/images/icons/automatedml.svg";
import { ReactComponent as Jumpstart } from "../../../../../../assets/images/icons/jumpstart.svg";
import { ReactComponent as Explanations } from "../../../../../../assets/images/icons/explanations.svg";
import { ReactComponent as Clarify } from "../../../../../../assets/images/icons/clarify.svg";

export const FeaturedProducts1 = [
  {
    icon: <Chatbots />,
    title: "Communication Bots",
    desc: "Build conversional agents to improve customer service",
    path: "/chatbots",
  },
  {
    icon: <PersonalAssistant />,
    title: "Personal Assistant",
    desc: "Create your own personal assistant",
    path: "/personalassistant",
  },
  {
    icon: <TextAnalytics />,
    title: "Text Analytics",
    desc: "Use NPL to extract insights from unstructured text",
    path: "/textanalytics",
  },
  {
    icon: <CodeReview />,
    title: "Code Review",
    desc: "Find critical issues, security vulnerabilities and hard-to-find bugs ",
    path: "/code-review",
  },
  {
    icon: <NoiseCancelling />,
    title: "Noise Cancelling",
    desc: "AI-powered service that removes background noise and echo",
    path: "/noisecancelling",
  },
];
export const FeaturedProducts2 = [
  {
    icon: <Search />,
    title: "Enterprise Search",
    desc: "Find the information you need more easily",
    path: "/enterprisesearch",
  },
  {
    icon: <TextToSpeech />,
    title: "Text to Speech",
    desc: "Turn text into life-like speech to give voice to your applications",
    path: "/texttospeech",
  },
  {
    icon: <Image />,
    title: "Image and Video Analysis",
    desc: "Add image analysis to your applications ",
    path: "/imageanalysis",
  },
  {
    icon: <Translation />,
    title: "Translate AI",
    desc: "Translate text or instant live videos in any language",
    path: "/translateai",
  },
  {
    icon: <TextSummarize />,
    title: "Text Summarize",
    desc: "Helps you summarize any piece of text into concise, easy to digest content ",
    path: "/text-summarize",
  },
];
export const FeaturedProducts3 = [
  {
    icon: <PersonalizedRecommendations />,
    title: "Personalized Recommendations ",
    desc: "Personalize experiences for your customers ",
    path: "/personalizedrecommendations",
  },
  {
    icon: <Forecast />,
    title: "HostAI Forecast",
    desc: "Build accurate forecasting models",
    path: "/forecast",
  },
  {
    icon: <FraudDetector />,
    title: "Fraud Detector",
    desc: "Identify potentially fraudulent online activities",
    path: "/frauddetector",
  },
  {
    icon: <DocumentAnalysis />,
    title: "Document Analysis",
    desc: "Automatically extract text and data from millions of documents",
    path: "/documentanalysis",
  },
  {
    icon: <UIdesign />,
    title: "UI Design Automation",
    desc: "AI to create your UI design, UX workflows, and front-end code",
    path: "/uidesign",
  },
];

export const IntelligentApps1 = [
  {
    icon: <HostAssistant />,
    title: "HostAssistant",
    desc: "Create your own personal assistant for all your tasks",
    path: "/personalassistant",
  },
  {
    icon: <WritingAssistant />,
    title: "Writing Assistant",
    desc: "Make clear writing without any mistake",
    path: "/whats_new",
  },
  {
    icon: <TextAnalytics />,
    title: "Text Analytics",
    desc: "Use NPL to extract insights from unstructured text",
    path: "/textanalytics",
  },
  {
    icon: <Home />,
    title: "HostAI Home",
    desc: "AI solutions and robots to help you run your home",
    path: "/try-hostai",
  },
  {
    icon: <OS />,
    title: "HostX OS AI",
    desc: "Operating System powered by AI",
    path: "/try-hostai",
  },
];
export const IntelligentApps2 = [
  {
    icon: <Search />,
    title: "Enterprise Search",
    desc: "Find the information you need more easily",
    path: "/enterprisesearch",
  },
  {
    icon: <TextSummarize />,
    title: "Text Summarize",
    desc: "Helps you summarize any piece of text into concise, easy to digest content ",
    path: "/ai-apps",
  },
  {
    icon: <DocumentAnalysis />,
    title: "Document Analysis",
    desc: "Automatically extract text and data from millions of documents",
    path: "/documentanalysis",
  },
  {
    icon: <CodeReview />,
    title: "Automated Code Review",
    desc: "Find critical issues, security vulnerabilities and hard-to-find bugs ",
    path: "/code-review",
  },
  {
    icon: <Game />,
    title: "Game AI",
    desc: "Build automatic game mechanics using cutting-edge algorithms",
    path: "/data-collection",
  },
];
export const IntelligentApps3 = [
  {
    icon: <PersonalizedRecommendations />,
    title: "Personalized Recommendations ",
    desc: "Personalize experiences for your customers ",
    path: "/personalizedrecommendations",
  },
  {
    icon: <UIdesign />,
    title: "UI Design Automation",
    desc: "AI to create your UI design, UX workflows, and front-end code",
    path: "/build-custom-ai",
  },
  {
    icon: <FraudDetector />,
    title: "Fraud Detector",
    desc: "Identify potentially fraudulent online activities",
    path: "/frauddetector",
  },
  {
    icon: <FileManagement />,
    title: "File Management",
    desc: "All files will be automatically interpreted, stored, and indexed on cloud storage",
    path: "/trusted-ai",
  },
  {
    icon: <Texture />,
    title: "Texture AI",
    desc: "Create automatically textures based on given examples",
    path: "/build-custom-ai",
  },
];

export const ControlSystem1 = [
  {
    icon: <Factory />,
    title: "Factory Automation",
    desc: "Robotics automation solutions for factory",
    path: "/platform-overview",
  },
  {
    icon: <MotionControl />,
    title: "Motion control",
    desc: "Optimize movement and trajectory for robotic arms and industrial machines",
    path: "/whats_new",
  },
  {
    icon: <MachineController />,
    title: "Machine Controller",
    desc: "Control machine operations and get alerts on potencial failures",
    path: "/getting-started",
  },
];
export const ControlSystem2 = [
  {
    icon: <LogisticAutomation />,
    title: "Logistics Automation",
    desc: "Robotics automation solutions for logistics ",
    path: "/api",
  },
  {
    icon: <MachineCalibration />,
    title: "Machine Calibration",
    desc: "Automate the calibration of machine in seconds or minutes",
    path: "/mlops",
  },
  {
    icon: <StockAnalysis />,
    title: "Safety Stock Analysis",
    desc: "Rapidly run safety-stock analysis across all distribution centers",
    path: "/data-collection",
  },
];
export const ControlSystem3 = [
  {
    icon: <ProcessOptimization />,
    title: "Process optimization",
    desc: "Automatically control dynamic and complex processes",
    path: "/automated-ml",
  },
  {
    icon: <SmartCameras />,
    title: "Smart Cameras",
    desc: "Turn your existing onsite cameras into powerful AI devices",
    path: "/trusted-ai",
  },
];
export const Business1 = [
  {
    icon: <Search />,
    title: "Enterprise Search",
    desc: "Find the information you need more easily",
    path: "/enterprisesearch",
  },
  {
    icon: <FraudDetector />,
    title: "Fraud Detector",
    desc: "Identify potentially fraudulent online activities",
    path: "/frauddetector",
  },
  {
    icon: <PredictiveIntelligence />,
    title: "Predictive Intelligence",
    desc: "Solve issues quickly with smart suggestions powered by NLP",
    path: "/getting-started",
  },
  {
    icon: <MediatedConversations />,
    title: "AI-Mediated Conversations",
    desc: "Matching agents with customers to improve calls and enhance customer satisfaction",
    path: "/try-hostai",
  },
];
export const Business2 = [
  {
    icon: <PersonalizedRecommendations />,
    title: "Personalized Recommendations ",
    desc: "Personalize experiences for your customers ",
    path: "/personalizedrecommendations",
  },
  {
    icon: <Metrics />,
    title: "HostAI Metrics",
    desc: "Automatically detect unexpected changes in metrics  ",
    path: "/mlops",
  },
  {
    icon: <CustomerService />,
    title: "Customer Service Intelligence",
    desc: "Improve your customer service experience and reduce costs",
    path: "/data-collection",
  },
];
export const Business3 = [
  {
    icon: <Forecast />,
    title: "HostAI Forecast",
    desc: "Build accurate forecasting models",
    path: "/forecast",
  },
  {
    icon: <DataIntelligence />,
    title: "Data Intelligence",
    desc: "Use data intelligence to process distributed data",
    path: "/automated-ml",
  },
  {
    icon: <CallTracking />,
    title: "Call Tracking Software",
    desc: "Maximize the value of every caller with inbound call tracking software",
    path: "/visual-ai",
  },
];
export const Media1 = [
  {
    icon: <Image />,
    title: "Image and Video Analysis",
    desc: "Extract data from any image or video with HostAI ",
    path: "/platform-overview",
  },
  {
    icon: <AiVoices />,
    title: "AI Voices",
    desc: "Create your unique AI voice in any language",
    path: "/whats_new",
  },
  {
    icon: <SoundCreation />,
    title: "Sound Creation",
    desc: "Create sound for silent video with the power of AI",
    path: "/getting-started",
  },
  {
    icon: <MediaOptimize />,
    title: "Media Optimize AI",
    desc: "High-quality denoising filters for images and audio files",
    path: "/try-hostai",
  },
];
export const Media2 = [
  {
    icon: <VideoEdit />,
    title: "Video Content Editing",
    desc: "Have all video editing options in one AI platform",
    path: "/",
  },
  {
    icon: <VideoCreation />,
    title: "AI Video Creation",
    desc: "Create your own AI videos for business or marketing",
    path: "/mlops",
  },
  {
    icon: <ImageInhancer />,
    title: "AI Image Enhancer",
    desc: "Make low quality, blurred images into high-definition images",
    path: "/data-collection",
  },
  {
    icon: <MediaTool />,
    title: "Media Tool AI",
    desc: "Monitor, store, transfer and convert videos online",
    path: "/ai-apps",
  },
];
export const Media3 = [
  {
    icon: <AudioEditing />,
    title: "Audio Editing",
    desc: "Have all audio editing options in one AI platform",
    path: "/automated-ml",
  },
  {
    icon: <NoiseCancelling />,
    title: "Noise Cancelling",
    desc: "AI-powered service that removes background noise and echo",
    path: "/noisecancelling",
  },
  {
    icon: <Objects />,
    title: "Objects AI",
    desc: "Extract and change objects, or faces from images and videos",
    path: "/visual-ai",
  },
];

export const LanguageAi1 = [
  {
    icon: <Chatbots />,
    title: "Communication Bots",
    desc: "Build conversional agents to improve customer service",
    path: "/platform-overview",
  },
  {
    icon: <SpeechToText />,
    title: "Speech to Text",
    desc: "Automatically convert speech to text in seconds",
    path: "/whats_new",
  },
];
export const LanguageAi2 = [
  {
    icon: <Translation />,
    title: "Translate AI",
    desc: "Translate text or instant live videos in any language",
    path: "/translateai",
  },
  {
    icon: <AiVoices />,
    title: "AI Voices",
    desc: "Create your unique AI voice in any language",
    path: "/mlops",
  },
];
export const LanguageAi3 = [
  {
    icon: <TextToSpeech />,
    title: "Text to Speech",
    desc: "Turn text into life-like speech to give voice to your applications",
    path: "/texttospeech",
  },
  {
    icon: <LanguageLearn />,
    title: "Language Learn",
    desc: "Custom AI-generated lessons or suggestions to help you learn languages",
    path: "/trusted-ai",
  },
];
export const MachineLearningServices1 = [
  {
    icon: <OS />,
    title: "HostAI Develop",
    desc: "Integrated environment to build, train and deploy ML models ",
    path: "/platform-overview",
  },
  {
    icon: <VisualAi />,
    title: "Visual AI",
    desc: "Enables classification and regression of use cases with images and videos",
    path: "/whats_new",
  },
];
export const MachineLearningServices2 = [
  {
    icon: <AutomatedML />,
    title: "Automated ML ",
    desc: "Develop advanced machine learning models in an automated and democratized way",
    path: "/api",
  },
  {
    icon: <Jumpstart />,
    title: "HostAI Jumpstart",
    desc: "Provides a set of solutions for common ML use cases",
    path: "/mlops",
  },
];
export const MachineLearningServices3 = [
  {
    icon: <Explanations />,
    title: "Human-Friendly Explanations",
    desc: "HostAI provides fully explainable AI through human-friendly visual insights",
    path: "/automated-ml",
  },
  {
    icon: <Clarify />,
    title: "HostAI Clarify",
    desc: "Analyze ML models to detect biases and understand predictions",
    path: "/trusted-ai",
  },
];
